import { apiGetCasinosSummary, apiGetGameTypes, apiGetGameThemes, apiGetGameCategories } from './api';
import { mapEnabled } from './store/services/mapEnabled';
import { cleanSource } from './utilities';

// Factory function
function getList (apiFunc, mapProperties = ['slug', 'name']) {
  return apiFunc()
    .then(({ data }) => {
      // Add enabled to each so we can easily use the array for filters/checkboxes
      return mapEnabled(data.data, mapProperties);
    })
    .catch((error) => {
      console.log(error);
    });
}

let casinos = [];

async function getCasinosAsList (clearCache = false) {
  if (clearCache) casinos = [];
  if (casinos.length) return cleanSource(casinos);

  casinos = await getList(apiGetCasinosSummary);

  return cleanSource(casinos);
}

let gameTypes = [];

async function getGameTypesAsList (clearCache = false) {
  if (clearCache) gameTypes = [];
  if (gameTypes.length) return cleanSource(gameTypes);

  gameTypes = await getList(apiGetGameTypes);

  return cleanSource(gameTypes);
}

let gameThemes = [];

async function getGameThemesAsList (clearCache = false) {
  if (clearCache) gameThemes = [];
  if (gameThemes.length) return cleanSource(gameThemes);

  gameThemes = await getList(apiGetGameThemes);

  return cleanSource(gameThemes);
}

let gameCategories = [];

async function getGameCategoriesAsList (clearCache = false) {
  if (clearCache) gameCategories = [];
  if (gameCategories.length) return cleanSource(gameCategories);

  gameCategories = await getList(apiGetGameCategories);

  return cleanSource(gameCategories);
}

export {
  getCasinosAsList,
  getGameTypesAsList,
  getGameThemesAsList,
  getGameCategoriesAsList
}


// WEBPACK FOOTER //
// ./resources/assets/js/app/lists.js